import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { CapturumInputComponent } from '@capturum/ui/input';
import { ManageValidatorDisplayDirective } from '@features/client/form-builder/directives/hide-validator.directive';
import { ReactiveFormsModule } from '@angular/forms';
import { FormTooltipComponent } from '@shared/components/form-tooltip/form-tooltip.component';

@Component({
  selector: 'app-number-input',
  templateUrl: './number-input.component.html',
  imports: [CapturumInputComponent, ManageValidatorDisplayDirective, ReactiveFormsModule, FormTooltipComponent],
})
export class NumberInputComponent extends FieldType {}
